import { Logos } from "@yodlee/common-components/dist/assets";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { Col, Row } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { useMediaQuery } from "react-responsive";

const Disclaimer: React.FC = () => {

    let isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD });
    const isIEBrowser = window.navigator.userAgent?.includes("Trident");
    return <div>
        <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <img alt="env-ydle" src={Logos.EnvestnetYodleeLabel} style={{ position: "absolute", top: "32px", right: "32px", maxHeight: "48px" }} />
                <div style={{ maxWidth: "685px" }}>
                    <Row type="flex" style={isIEBrowser ? { height: "100vh" } : { minHeight: "100vh" }} justify="center" align="middle">

                        <Col style={isMD ? { padding: "0 0 0 100px" } : { padding: "100px 40px" }}>
                            <Row >
                                <Title className='color-blue'>My Yodlee - Terms of Use</Title>
                            </Row>
                            <Row>
                                <p>
                                    Yodlee provides My Yodlee to customers and other authorized entities.
                                </p>
                                <p>
                                    Yodlee may, at our discretion, at any time, with or without notice, make changes to My Yodlee.
                                </p>
                                <p>
                                    Information in My Yodlee may not be accurate and is provided only for informational purposes, not for trading or transactional purposes.
                                </p>
                                <p>
                                    Yodlee is not liable for any damages or costs of any type arising out of or in any way connected with your use of the services of any financial institution, advisor, or other service provider. Additionally, Yodlee is not liable for any errors or delays in the content, information, data, calculations, and advice users may receive relative thereto or for any actions taken in reliance thereon.
                                </p>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </div>
};

export default Disclaimer;
